module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pers-tab2-4",
      "name": "hrms32e-tab2-tab4"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC6']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-num"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC14']['20']) + " " + _vm._s(1))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC6']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codbank[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codbank),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codbank", $$v)
      },
      expression: "detail.codbank"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC6']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numbank),
      expression: "detail.numbank"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:15'),
      expression: "'max:15'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numbank",
      "name": "numbank",
      "maxlength": "15",
      "data-vv-name": "numbank",
      "has-error": _vm.errors.has('numbank')
    },
    domProps: {
      "value": (_vm.detail.numbank)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numbank", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numbank')),
      expression: "errors.has('numbank')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numbank')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC6']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.amtbank),
      expression: "detail.amtbank"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('decimal:2|max:6'),
      expression: "'decimal:2|max:6'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "amtbank",
      "name": "amtbank",
      "maxlength": "6",
      "data-vv-name": "amtbank",
      "has-error": _vm.errors.has('amtbank')
    },
    domProps: {
      "value": (_vm.detail.amtbank)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "amtbank", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('amtbank')),
      expression: "errors.has('amtbank')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('amtbank')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 pull-right"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic2
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC6']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-num"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC14']['20']) + " " + _vm._s(2))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic2),
      expression: "subTopic2"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC6']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codbank[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codbank2),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codbank2", $$v)
      },
      expression: "detail.codbank2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC6']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numbank2),
      expression: "detail.numbank2"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:15'),
      expression: "'max:15'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numbank2",
      "name": "numbank2",
      "maxlength": "15",
      "data-vv-name": "numbank2",
      "has-error": _vm.errors.has('numbank2')
    },
    domProps: {
      "value": (_vm.detail.numbank2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numbank2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numbank2')),
      expression: "errors.has('numbank2')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numbank2')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray pull-left",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.togglePage(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79c92fa2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms32e/tab2_4.vue
// module id = 3908
// module chunks = 1